import React, { useEffect } from 'react';
import '../Styles/SignInTypeSelection.css';
import logo from '../Images/SAVI AI full.png';
import { useNavigate } from 'react-router-dom';

const SignInTypeSelection = () => {
  const navigate = useNavigate();

  const handleSaviAISignIn = () => {
    navigate('/login');
  };

  const handleVendorSignIn = () => {
    navigate('/vendor-login');
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  useEffect(() => {
    const setTheme = () => {
      const savedTheme = localStorage.getItem('theme') || 'light';
      document.documentElement.setAttribute('data-theme', savedTheme);
    };
    setTheme();

    const handleStorage = (e) => {
      if (e.key === 'theme') {
        setTheme();
      }
    };
    window.addEventListener('storage', handleStorage);

    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  return (
    <div className="signin-type-main-container">
      <header className="signin-type-header">
        <div className="signin-type-logo">
          <img src={logo} alt="Logo" className="signin-type-logo-image" />
        </div>
      </header>

      <div className="signin-type-content-container">
        <div className="signin-type-welcome-box">
          <div className="signin-type-title-highlight">Welcome!</div>
          <div className="signin-type-subtitle">Please pick a sign-in option</div>

          <div className="signin-type-buttons-container">
            <button className="signin-type-saviai-button" onClick={handleSaviAISignIn}>
              Savi AI Sign In
            </button>
            <button className="signin-type-vendor-button" onClick={handleVendorSignIn}>
              OCR Sign In
            </button>
          </div>

          {/* <div className="signin-type-info-text">
            Select the appropriate sign-in method for your account type.
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default SignInTypeSelection;
